import template from './header.menuitem.tpl.html';

export const menuitem = {
    bindings: {
        displayText: '@',
        linkAddress: '@',
        clickAction: '&',
        sectionLast: '@',
        hasChildren: '@',
        newTab: '@',
        adminOnly: '@'
    },
    template
};
